import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { AlertTriangle, Thermometer, Phone, FileWarning } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useToast } from '@/hooks/use-toast';

const EmergencyActionsCard = () => {
  const navigate = useNavigate();
  const { toast } = useToast();

  const handleEmergencyIncident = () => {
    navigate('/incidents');
    toast({
      title: "Emergency Incident Report",
      description: "Document critical incidents immediately for compliance",
    });
  };

  const emergencyActions = [
    {
      title: 'Report Critical Incident',
      description: 'Food safety emergency or violation',
      icon: AlertTriangle,
      color: 'text-red-500',
      bgColor: 'bg-red-500/10',
      action: handleEmergencyIncident
    },
    {
      title: 'Temperature Out-of-Range',
      description: 'Log unsafe temperature readings',
      icon: Thermometer,
      color: 'text-orange-500',
      bgColor: 'bg-orange-500/10',
      action: () => navigate('/templates')
    },
    {
      title: 'Emergency Contacts',
      description: 'View critical contact list',
      icon: Phone,
      color: 'text-blue-500',
      bgColor: 'bg-blue-500/10',
      action: () => {
        toast({
          title: "Emergency Contacts",
          description: "Local EHO: 0800-123-4567 | Food Standards Agency: 0330-332-7149",
        });
      }
    },
    {
      title: 'Health Inspector Arrived',
      description: 'Quick audit prep checklist',
      icon: FileWarning,
      color: 'text-purple-500',
      bgColor: 'bg-purple-500/10',
      action: () => navigate('/checklists')
    }
  ];

  return (
    <Card className="glass-panel border-2 border-red-500/30">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-red-500">
          <AlertTriangle className="h-5 w-5" />
          Emergency Actions
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        {emergencyActions.map((action) => {
          const Icon = action.icon;
          return (
            <Button
              key={action.title}
              variant="outline"
              className="w-full justify-start h-auto py-3 px-4 glass-button hover:glass-panel-elevated"
              onClick={action.action}
            >
              <div className="flex items-start gap-3 w-full">
                <div className={`p-2 rounded-lg ${action.bgColor} flex-shrink-0`}>
                  <Icon className={`h-5 w-5 ${action.color}`} />
                </div>
                <div className="text-left flex-1">
                  <div className="font-semibold text-sm">{action.title}</div>
                  <div className="text-xs text-muted-foreground">{action.description}</div>
                </div>
              </div>
            </Button>
          );
        })}
      </CardContent>
    </Card>
  );
};

export default EmergencyActionsCard;
